import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { Flex, Flex1, Flex5 } from "../../../../../../common/style";
import Select from "@atlaskit/select";
import { METHOD_OPTIONS } from "../../../../../../common/constants/core/integration.constants";
import { useSelector, useDispatch } from "react-redux";
import Body from "./Body";
import CredentialPicker from "../../../../../../auth/CredentialPicker";
import { useParams } from "react-router-dom";
import { setEditorSaved, selectCurrentURL, rerender } from "../../../../../../redux/actions/integrationActions";
import { getBaseURL } from "../../../../../../env/stage";
import { addMessage } from "../../../../../../redux/actions/messageActions";
import MidSectionExtensions from "../../extension/MidSectionExtensions";
import RequestType from "./RequestType";
import { Label } from "@atlaskit/form";
import ShowFullScopeVariablePathHint from "../../extension/ShowFullScopeVariablePathHint";
import HTTPHeaders from "../../Header/HTTPHeaders";
import ResponseHandlingConfiguration from "./ResponseHandlingConfiguration";

const RequestConfiguration = () => {
  const dispatch = useDispatch();

  const flow = useSelector((state) => state.integration.flow);
  const { sectionId } = useParams();

  const [method, setMethod] = useState("");
  const [urlField, setUrl] = useState("");
  const [credential, setCredential] = useState("");
  const [currentAction, setCurrentAction] = useState(null);

  useEffect(() => {
    if (flow.actions) {
      const action = flow.actions.find((a) => a.id === sectionId);
      if (action) {
        setUrl(action.url ? action.url : "");
        setMethod(METHOD_OPTIONS.find((mo) => mo.value === action.method));
        setCredential(action.credentialsReference);
        setCurrentAction(action);
      }
    }
  }, [sectionId, flow]);

  const onChange = (e) => {
    switch (e.target.name) {
      case "url":
        if (!e.target.value.includes(getBaseURL() + "/incoming/webhook")) {
          setUrl(e.target.value);
          currentAction.url = e.target.value;
          dispatch(selectCurrentURL(e.target.value));
        } else {
          dispatch(addMessage("Invalid url", "You cannot post from ihub to ihub", "warn"));
        }
        break;
      case "body":
        currentAction.body = e.target.value;
        break;
      default:
        break;
    }
    setCurrentAction(currentAction);
    mergeCurrentActionToFlow();
    dispatch(setEditorSaved(false));
  };
  const onMethodSelect = (methodOption) => {
    setMethod(methodOption);
    currentAction.method = methodOption.value;
    mergeCurrentActionToFlow();
    dispatch(setEditorSaved(false));
  };
  const selectCredential = (credential) => {
    setCredential(credential);
    currentAction.credentialsReference = credential;
    mergeCurrentActionToFlow();
    dispatch(setEditorSaved(false));
  };
  const updateCallback = () => {
    mergeCurrentActionToFlow();
    dispatch(setEditorSaved(false));
  };

  const mergeCurrentActionToFlow = () => {
    const action = flow.actions.find((a) => a.id === sectionId);
    const index = flow.actions.indexOf(action);
    flow.actions[index] = currentAction;
    dispatch(rerender());
  };

  return (
    <div className="ihub-action-page">
      <div className="ihub-webaction-header">
        <p className="ihub-action-tab-description">Here you configure how your action connects with external services or platforms. </p>
      </div>
      <Flex>
        <Flex1>
          <Label>Method:</Label>
          <Select
            options={METHOD_OPTIONS}
            spacing="compact"
            isRequired={true}
            onChange={onMethodSelect}
            name="selectedMethod"
            value={method}
            className="ihub-action-method-select"
          />
        </Flex1>
        <Flex5>
          <Label>URL:</Label>
          <Textfield isCompact={true} onChange={onChange} label="URL" name="url" isRequired={true} value={urlField} />
        </Flex5>
      </Flex>
      <Label>Authorization:</Label>
      <CredentialPicker onSelect={selectCredential} value={credential?.value} />
      <ResponseHandlingConfiguration action={currentAction} updateCallback={updateCallback} />
      <HTTPHeaders action={currentAction} />
      <MidSectionExtensions />
      <RequestType updateCallback={updateCallback} action={currentAction} />
      <Body onChange={onChange} action={currentAction} />
      <ShowFullScopeVariablePathHint />
    </div>
  );
};
export default RequestConfiguration;
